export type AppointmentStatus = 0 | 1 | 2 | 3 | 4;
export interface Appointment {
  id: string;
  store_id: string;
  customer_id: string | null;
  customer_name: string;
  customer_phone: string;
  employee_id: string | null;
  employee_name: string;
  appointment_time_ms: number;
  duration_minutes: number;
  service_ids: string[];
  service_snapshots: { id?: string; title?: string; name?: string; price?: number }[];
  combo_ids: string[];
  combo_snapshots: { id?: string; title?: string }[];
  total_price: number;
  status_raw: AppointmentStatus;
  note: string | null;
  source: 'local' | 'online';
  bill_id?: string | null;
}
export const appointmentStatuses: Record<AppointmentStatus, { label: string; tone: 'blue' | 'green' | 'neutral' | 'red' | 'amber' }> = {
  0: { label: 'Sắp tới', tone: 'blue' },
  1: { label: 'Đang phục vụ', tone: 'amber' },
  2: { label: 'Hoàn thành', tone: 'green' },
  3: { label: 'Đã hủy', tone: 'neutral' },
  4: { label: 'Không đến', tone: 'red' },
};
export function appointmentTitle(item: Appointment) {
  return [...item.service_snapshots.map(s => s.title || s.name), ...item.combo_snapshots.map(s => s.title)].filter(Boolean).join(' + ') || 'Dịch vụ chưa có thông tin';
}
